module.exports = __webpack_public_path__ + "static/media/image-card-1.89da4098.png";